export default "__VITE_ASSET__CpgEwZKP__"